import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { guaranteeItems } from '../../data/content';
export function Guarantee() {
  return <section className="bg-white px-5 py-16 sm:py-24" data-id="element-190" data-mp="24mommw1f3ih5">
      <div className="mx-auto max-w-3xl rounded-[28px] bg-cream p-6 text-center ring-1 ring-brand-100 sm:p-12" data-id="element-191" data-mp="24l3tnaur47le">
        <span className="mx-auto grid h-20 w-20 place-items-center rounded-full bg-brand-700 text-white" data-id="element-192" data-mp="29frg74672rxc">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-193" data-mp="2jc4ao49kd9t5" />
        </span>
        <p className="mt-5 text-xs font-bold uppercase tracking-[0.16em] text-brand-600 sm:text-sm" data-id="element-194" data-mp="2jdxkfsfh4a5d">7-day money-back guarantee</p>
        <h2 className="mt-2 font-display text-[30px] font-bold leading-tight text-ink sm:text-5xl" data-id="element-195" data-mp="2sdaw8rr2lat9">Try it for 7 days</h2>
        <p className="mt-4 text-[17px] leading-relaxed text-ink-soft" data-id="element-196" data-mp="ty7ung2e9tmg">
          I want you to be able to explore the system before deciding whether it fits you. During your guarantee period,
          you can:
        </p>
        <ul className="mx-auto mt-6 grid max-w-lg gap-2.5 text-left sm:grid-cols-2" data-id="element-197" data-mp="3smztzin7o85z">
          {guaranteeItems.map(g => <li key={g} className="flex items-center gap-2.5 rounded-xl bg-white px-4 py-3 text-[16px] font-semibold text-ink" data-id="element-198" data-mp="3nsvhykz399y1">
              <CheckIcon className="h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-199" data-mp="3dx27d74xjqiw" />
              {g}
            </li>)}
        </ul>
        <p className="mt-6 text-[16px] leading-relaxed text-ink-soft" data-id="element-200" data-mp="fctyp72cm9ji">
          If, after exploring the material, you decide the 7D Apometry Protocol™ isn’t right for you, you can request a
          refund within the applicable guarantee period.
        </p>
        <CtaButton label="I want to try the 7D Protocol™" className="mt-8" data-id="element-201" data-mp="gm7hmsiw7uq" />
      </div>
    </section>;
}